<template>
  <div class="dropoff-data-integrity">
    <img
      src="@/assets/dropoff-data-integrity.png"
      alt="DropOff Data Integrity Message"
      class=""
    >
    <p class="dropoff-data-integrity-summary">
      Our data suggests that you may not be utilizing the field(s)
      that your ATS provides to capture candidate drop-offs.
    </p>
    <h3>With better data integrity around candidate drop-offs you can:</h3>
    <ul>
      <li>
        Get instant insights about candidate drop-off rates at the organization,
        department, location (and beyond) levels
      </li>
      <li>
        Effortlessly determine which stages candidates are dropping out of your hiring process
      </li>
      <li>
        Benchmark your drop-off rates internally as well as externally
      </li>
    </ul>
    <p class="dropoff-data-integrity-details">
      The Drop-off Report will not be useful until drop-offs are being accurately
      captured in your ATS,<br>
      therefore it will not be accessible for the time being.<br>
      Please reach out to your Datapeople Customer Success Manager if you think
      this is incorrect.<br>
      <a
        href="#"
        data-beacon-article-sidebar="654ad142d6c4276986645dd3"
        @click.stop
      >
        Click here to learn how to collect candidate attrition data more effectively.
      </a>
    </p>
    <DpplAutoSizedButton
      href="mailto:support@datapeople.io?subject=Drop-off%20Report%20Data%20Integrity%20Inquiry"
    >
      Contact Us
    </DpplAutoSizedButton>
  </div>
</template>

<script setup>
import DpplAutoSizedButton from '@/components/datapeople/DpplAutoSizedButton.vue';
</script>

<style scoped lang="less">
.dropoff-data-integrity {
  color: @text-darkest;
  background-color: @white;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 36px 36px 24px 36px;
  border-radius: 10px;
  box-shadow: 0 5px 20px rgba(31,45,67,.1);

  &-summary {
    font-style: italic;
    font-weight: 400;
    font-size: 16px;
    line-height: 18.75px;
    padding-top: 36px;
  }

  h3 {
    font-weight: 700;
    font-size: 24px;
    line-height: 36px;
    padding-top: 24px;
  }

  ul {
    padding-top: 8px;
    list-style-position: inside;
    li {
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
    }
  }

  &-details {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    padding-top: 36px;
    padding-bottom: 24px;

    a {
      text-decoration: underline;
      color: @text-brand;
    }
  }
}
</style>
